import { JsonObject } from 'json2typescript';
import { ActivityTypeResponseInterface } from '../interfaces/activitytype-response.interface';

@JsonObject('ActivityTypeResponseModel')
export class ActivityTypeResponseModel implements ActivityTypeResponseInterface {
  Type?: string;
  TypeName: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
